import { http } from '../../../../api/http';
import type { Dependiente } from '../types/dependiente.types';

const BASE = '/planilla/trabajador/dependiente';

export class DependienteService {
  static async getByTrabajador(idTrabajador: number): Promise<Dependiente[]> {
    const { data } = await http.get(`${BASE}/${idTrabajador}`);
    return data;
  }

  static async getById(id: number): Promise<Dependiente> {
    const { data } = await http.get(`${BASE}/detalle/${id}`);
    return data;
  }

  static async save(dependiente: Dependiente): Promise<Dependiente> {
    const { data } = await http.post(BASE, dependiente);
    return data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  }

  static async contarHijos(idTrabajador: number): Promise<number> {
    const { data } = await http.get(`${BASE}/${idTrabajador}/contar-hijos`);
    return data.count;
  }
}
